import { checkKeyDown } from '../helper/keyDown';

/**
 * Header Search functionality
 *
 * @package
 * @since 1.0.0
 */
export const headerSearch = () => {
	/**
	 * Search Toggle Behaviors
	 *
	 * @param {string} id Navigation ID
	 */
	const searchModal = function ( id ) {
		const selectors = 'input, a, button';
		const body = document.body;
		const toggleButton = document.querySelector( '.js-' + id + '-toggle' );
		const searchField = document.querySelector( '.js-' + id + '-field' );
		const modal = document.querySelector( '#' + id + '-form' );
		let modalElements = modal.querySelectorAll( selectors );
		modalElements = Array.prototype.slice.call( modalElements );

		if ( toggleButton ) {
			toggleButton.onclick = function () {
				body.classList.toggle( id + '-open' );
				toggleButton.setAttribute(
					'aria-expanded',
					toggleButton.getAttribute( 'aria-expanded' ) === 'true'
						? 'false'
						: 'true'
				);

				// Set the focus based on search form being visible or not.
				if ( toggleButton.getAttribute( 'aria-expanded' ) === 'true' ) {
					searchField.focus();
				} else {
					toggleButton.focus();
				}
			};
		}

		/**
		 * Trap keyboard navigation in the search modal.
		 */
		document.addEventListener( 'keydown', function ( event ) {
			if ( ! body.classList.contains( id + '-open' ) ) {
				return;
			}

			const tabKey = checkKeyDown( event.key, 'Tab' );
			const shiftKey = checkKeyDown( event.key, 'Shift' );
			const escKey = checkKeyDown( event.key, 'Escape' );
			const activeEl = document.activeElement; /* eslint-disable-line */
			const lastEl = modalElements[ modalElements.length - 1 ];
			const firstEl = modalElements[ 0 ];

			if ( escKey ) {
				event.preventDefault();
				body.classList.remove( id + '-open' );
				toggleButton.focus();
			}

			if ( ! shiftKey && tabKey && lastEl === activeEl ) {
				event.preventDefault();
				firstEl.focus();
			}

			if ( shiftKey && tabKey && firstEl === activeEl ) {
				event.preventDefault();
				lastEl.focus();
			}

			// If there are no elements in the search modal, don't move the focus
			if ( tabKey && firstEl === lastEl ) {
				event.preventDefault();
			}
		} );
	};

	// Initialize the search modal(s).
	window.addEventListener( 'load', function () {
		new searchModal( 'header-search' );
	} );
};
